'use strict';
module.exports = function trimLines(string){
	if (typeof string !== 'string') {
		return '';
	}
	return string.replace(/\r/g, '').split('\n').map(line => line.trim()).join('\n');
};
